import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { List } from 'immutable';
import classNames from 'classnames';

import { IconButton } from '../../../helpers/IconButton';
import style from './style.module.css';

const LOGO = 'Logo';
const CUSTOM = 'Custom';

const TableFilesComponent = ({ files, canEditData, onDeleteFile, onUploadFile }) => {
  const [fileName, setFileName] = useState(undefined);

  useEffect(() => {
    if (fileName) {
      onUploadFile();
      setFileName(undefined);
    }
  }, [onUploadFile, fileName]);

  const handleSelectFile = event => {
    setFileName(event.target.files.item(0).name.split('.')[0]);
  };

  const isFileExist = (files, type) =>
    files.size > 0 && files.filter(file => file.get('type') === type).getIn([0, 'id']) !== '';

  const isDisabledDelete = type => {
    if (type === CUSTOM) return false;

    return !isFileExist(files, type);
  };

  const getFileTypes = () => {
    const types = [CUSTOM];
    const isHasLogo = isFileExist(files, LOGO);

    if (!isHasLogo) {
      types.unshift(LOGO);
    }

    return types;
  };

  const handleDeleteClick = (event, onDeleteFile, file) => {
    event.preventDefault();
    event.stopPropagation();
    onDeleteFile(event, file);
  };

  return (
    <div className={style.host}>
      <div className={style.tableWrap}>
        <table className="table table-bordered table-align-middle">
          <thead>
            <tr>
              <th>Type</th>
              <th>Name</th>
              <th>Notes</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {files.map(file => (
              <tr key={file.get('id')}>
                <td className="text-left">{file.get('type')}</td>
                <td className="text-left">{file.get('fileName')}</td>
                <td className="text-left">{file.get('notes')}</td>
                <td className="pt5 pb5 text-center">
                  <div className={style.actions}>
                    <IconButton
                      disabled={isDisabledDelete(file.get('type'))}
                      icon="trash"
                      onClick={event => {
                        handleDeleteClick(event, onDeleteFile, file);
                      }}
                      size="sm"
                      title="Delete"
                      variant="danger"
                    />
                    <IconButton href={file.get('url')} icon="external-link" size="sm" title="Open" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {canEditData && (
        <div className={style.controls}>
          <select className={classNames(style.type, 'form-control input-sm')} name="type">
            {getFileTypes().map(type => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          <label className={classNames(style.upload, 'btn btn-sm btn-primary')} htmlFor="company-file-upload-file">
            <input
              className={classNames(style.fileInput, 'input-file-button')}
              id="company-file-upload-file"
              name="file"
              onChange={handleSelectFile}
              type="file"
            />
            Upload
          </label>
          <input name="name" type="hidden" value={fileName} />
        </div>
      )}
    </div>
  );
};

TableFilesComponent.propTypes = {
  canEditData: PropTypes.bool.isRequired,
  files: PropTypes.instanceOf(List).isRequired,
  onDeleteFile: PropTypes.func.isRequired,
  onUploadFile: PropTypes.func.isRequired,
};

/** Table files component. */
export const TableFiles = memo(TableFilesComponent);
